module.exports = __webpack_public_path__ + "img/grin-stars.2cb25d2e.svg";